export default __webpack_public_path__ + "static/media/course-icon.8b2c8e52.svg";